export const SET_USER = "SET_USER";
export const SET_TAGS = "SET_TAGS";
export const RESET_TAGS = "RESET_TAGS";
export const TOGGLE_LOGIN = "TOGGLE_LOGIN";
export const TOGGLE_REGISTRATION = "TOGGLE_REGISTRATION";
export const TOGGLE_EDIT = "TOGGLE_EDIT";
export const TOGGLE_EVENT_EDIT = "TOGGLE_EVENT_EDIT";
export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
